import { render, staticRenderFns } from "./ServiceListAddNew.vue?vue&type=template&id=c92eee32&"
import script from "./ServiceListAddNew.vue?vue&type=script&lang=js&"
export * from "./ServiceListAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports